import { render, staticRenderFns } from "./transaction.vue?vue&type=template&id=54ee15a2"
import script from "./transaction.vue?vue&type=script&lang=ts"
export * from "./transaction.vue?vue&type=script&lang=ts"
import style0 from "./transaction.vue?vue&type=style&index=0&id=54ee15a2&prod&module=true&lang=stylus"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports